let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7hb3L")).then(() => parcelRequire('iqAEB'));